import { Button } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import ButtonText from './ButtonText'
import { buttonHoverOutlineSx } from '../../theme/buttonHover'
import { responsiveButtonSx } from '../../theme/mobileLayout'

export default function OutlineButton({ children, to, onClick, sx = {}, fullWidth: _fullWidth, ...props }) {
  const buttonProps = to
    ? { component: RouterLink, to }
    : { onClick }

  return (
    <Button
      variant="outlined"
      disableElevation
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...responsiveButtonSx,
        ...buttonHoverOutlineSx,
        ...sx,
      }}
      {...buttonProps}
      {...props}
    >
      <ButtonText>{children}</ButtonText>
    </Button>
  )
}
